import styles from "./SectionTag.module.css";

export type SectionTagTone = "light" | "dark" | "muted";

export interface SectionTagProps {
  children: React.ReactNode;
  tone?: SectionTagTone;
  className?: string;
}

export function SectionTag({ children, tone = "light", className }: SectionTagProps) {
  return (
    <span className={[styles.tag, styles[tone], className].filter(Boolean).join(" ")}>
      {children}
    </span>
  );
}
